// Sticky Add to Cart com Modal

if (document.querySelector('[data-sticky-atc]')) {
  
  const stickyAtc = document.querySelector('[data-sticky-atc]');
  const mainAtcButton = document.querySelector('add-to-cart-component button[type="submit"]');
  const modal = document.querySelector('[data-sticky-modal]');
  const openModalBtn = document.querySelector('[data-sticky-open-modal]');
  const closeModalBtns = document.querySelectorAll('[data-sticky-close-modal]');
  const variantOptions = document.querySelectorAll('.sticky-variant-option');
  const modalVariantId = document.querySelector('[data-modal-variant-id]');
  const modalPrice = document.querySelector('[data-modal-price]');
  const modalSubmit = document.querySelector('[data-modal-submit]');
  const modalForm = document.querySelector('[data-modal-form]');
  
  if (mainAtcButton) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyAtc.classList.remove('visible');
          document.body.classList.remove('sticky-cart-visible');
        } else {
          stickyAtc.classList.add('visible');
          document.body.classList.add('sticky-cart-visible');
        }
      });
    }, { threshold: 0.1 });
    observer.observe(mainAtcButton);
  }

  if (openModalBtn && modal) {
    openModalBtn.addEventListener('click', function() {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });
  }
  
  closeModalBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    });
  });
  
  variantOptions.forEach(option => {
    option.addEventListener('click', function() {
      if (this.disabled) return;
      variantOptions.forEach(opt => opt.classList.remove('selected'));
      this.classList.add('selected');
      const variantId = this.getAttribute('data-variant-id');
      const variantPrice = this.getAttribute('data-variant-price');
      modalVariantId.value = variantId;
      if (modalPrice) modalPrice.textContent = variantPrice;
      if (modalSubmit) modalSubmit.disabled = false;
    });
  });
  
  if (modalForm) {
    modalForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      if (modalSubmit) {
        modalSubmit.disabled = true;
        modalSubmit.textContent = 'Adicionando...';
      }
      
      const formData = new FormData(this);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(() => {
        modal.style.display = 'none';
        document.body.style.overflow = '';
        
        if (modalSubmit) {
          modalSubmit.disabled = false;
          modalSubmit.textContent = 'Adicionar ao carrinho';
        }

        // Atualiza contador
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            document.querySelectorAll('.cart-bubble__text-count').forEach(bubble => {
              bubble.textContent = cart.item_count;
            });
          });

        // Abre o drawer com método nativo
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

        // Aguarda o drawer abrir, pega o sectionId correto de DENTRO do drawer
        setTimeout(() => {
          const cartItemsEl = document.querySelector('cart-drawer-component cart-items-component');
          const sectionId = cartItemsEl?.dataset?.sectionId;

          if (sectionId) {
            fetch(`/cart?sections=${sectionId}`)
              .then(r => r.json())
              .then(sections => {
                if (sections[sectionId]) {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(sections[sectionId], 'text/html');
                  const newItems = doc.querySelector('cart-items-component');
                  const currentItems = document.querySelector('cart-drawer-component cart-items-component');
                  if (newItems && currentItems) {
                    currentItems.innerHTML = newItems.innerHTML;
                    setTimeout(() => {
                      document.dispatchEvent(new CustomEvent('timer:injected'));
                      window.initUpsell && window.initUpsell();
                    }, 300);
                  }
                }
              });
          }
        }, 600);
      })
      .catch(error => {
        console.error('Erro ao adicionar ao carrinho:', error);
        alert('Erro ao adicionar ao carrinho. Tente novamente.');
        if (modalSubmit) {
          modalSubmit.disabled = false;
          modalSubmit.textContent = 'Adicionar ao carrinho';
        }
      });
    });
  }
}
